import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  OttoEmailScannerKuarPreview,
  OttoEmailScannerKuarRequest,
  OttoEmailScannerKuarResult
} from '../models/otto-olsen-emailscanner-kuar';

@Injectable({ providedIn: 'root' })
export class OttoOlsenEmailScannerKuarService {
  protected http = inject(HttpClient);

  private baseUrl = 'json/otto-olsen/emailscanner/kuar';

  getPreview(customerId: string, kArtnr: string, ooArtnr: string): Observable<OttoEmailScannerKuarPreview> {
    const params = new HttpParams().set('customerId', customerId).set('kArtnr', kArtnr || '').set('ooArtnr', ooArtnr || '');
    return this.http.get<OttoEmailScannerKuarPreview>(`${this.baseUrl}/preview`, { params, headers: { maxAge: '-1' } });
  }

  create(request: OttoEmailScannerKuarRequest): Observable<OttoEmailScannerKuarResult> {
    return this.http.post<OttoEmailScannerKuarResult>(`${this.baseUrl}/create`, request);
  }
}
